import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, NgZone } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Finding } from '../../../class/finding';
import { FindingService } from '../../../service/finding/finding.service';
import { TranslateService } from '@ngx-translate/core';
import { SelectItem, MultiSelectModule, AutoCompleteModule, CalendarModule } from 'primeng/primeng';
import { MapsAPILoader } from '@agm/core';
import { Marker } from '../../../../../interfaces/marker';
import { NotificationsService } from '../../../../../theme/services/notifications/notifications.service';
import { HasPermissionService } from '../../../service/has-permission/has-permission.service';
import { calendarES } from '../../../../../theme/functions/calendarES';

@Component({
  selector: 'app-new-finding',
  templateUrl: './new-finding.component.html',
  styleUrls: ['./new-finding.component.scss']
})
export class NewFindingComponent implements OnInit {
    @Output() msg: EventEmitter<object> = new EventEmitter<object>();
    @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() edit: Finding;
    public promiseForm: Promise<any>;
    public form: FormGroup;

    public department_id: AbstractControl;
    public responsable_id: AbstractControl;
    public venue_id: AbstractControl;
    public description: AbstractControl;
    public type_of_action: AbstractControl;
    public optionsSelectionType_of_action: any[];
    public source: AbstractControl;
    public optionsSelectionSource: any[];
    public status: AbstractControl;
    public optionsSelectionStatus: any[];
    public progress: AbstractControl;
    public currency: AbstractControl;
    public materials: AbstractControl;
    public manpower: AbstractControl;
    public methods: AbstractControl;
    public environment: AbstractControl;
    public machinery: AbstractControl;
    public decisions_cause_root: AbstractControl;
    public es: any;

    public save_exit: boolean;

    constructor(
        fb: FormBuilder,
        public findingService: FindingService,
        public translate: TranslateService,
        private notificationsService: NotificationsService) {

        this.save_exit = false;

        this.es = calendarES();

        this.optionsSelectionType_of_action = [];
            this.optionsSelectionType_of_action.push({label: 'Correctiva', value: 'Correctiva'});
            this.optionsSelectionType_of_action.push({label: 'Mejora', value: 'Mejora'});
            this.optionsSelectionType_of_action.push({label: 'Preventiva', value: 'Preventiva'});

        this.optionsSelectionSource = [];
            this.optionsSelectionSource.push({label: 'Accidente', value: 'Accidente'});
            this.optionsSelectionSource.push({label: 'Auditoria', value: 'Auditoria'});
            this.optionsSelectionSource.push({label: 'Incidente', value: 'Incidente'});
            this.optionsSelectionSource.push({label: 'No Conformidad Del Proceso', value: 'No Conformidad Del Proceso'});
            this.optionsSelectionSource.push({label: 'Producto No Conforme', value: 'Producto No Conforme'});
            this.optionsSelectionSource.push({label: 'Queja', value: 'Queja'});
            this.optionsSelectionSource.push({label: 'Re Ingenieria del Proceso', value: 'Re Ingenieria del Proceso'});
            this.optionsSelectionSource.push({label: 'Riesgo', value: 'Riesgo'}); 
            this.optionsSelectionSource.push({label: 'Solicitud', value: 'Solicitud'});

        this.optionsSelectionStatus = [];
            this.optionsSelectionStatus.push({label: 'Abierta', value: 'Abierta'});
            this.optionsSelectionStatus.push({label: 'Cerrada', value: 'Cerrada'});
            this.optionsSelectionStatus.push({label: 'Cancelada', value: 'Cancelada'});
        
        this.form = fb.group({
            'department_id': ['', Validators.compose([Validators.required])],
            'responsable_id': ['', Validators.compose([Validators.required])],
            'venue_id': ['', Validators.compose([Validators.required])],
            'description': ['', Validators.compose([Validators.required])],
            'type_of_action': ['', Validators.compose([Validators.required])],
            'source': ['', Validators.compose([Validators.required])],
            'status': ['', Validators.compose([Validators.required])],
            'progress': ['', Validators.compose([Validators.required])],
            'currency': [''],
            'materials': [''],
            'manpower': [''],
            'methods': [''],
            'environment': [''],
            'machinery': [''],
            'decisions_cause_root': [''],
        });

        
        this.department_id = this.form.controls['department_id'];
        this.responsable_id = this.form.controls['responsable_id'];
        this.venue_id = this.form.controls['venue_id'];
        this.description = this.form.controls['description'];
        this.type_of_action = this.form.controls['type_of_action'];
        this.source = this.form.controls['source'];
        this.status = this.form.controls['status'];
        this.progress = this.form.controls['progress'];
        this.currency = this.form.controls['currency'];
        this.materials = this.form.controls['materials'];
        this.manpower = this.form.controls['manpower'];
        this.methods = this.form.controls['methods'];
        this.environment = this.form.controls['environment'];
        this.machinery = this.form.controls['machinery'];
        this.decisions_cause_root = this.form.controls['decisions_cause_root'];
    }

    ngOnInit() {
        if (this.edit) {
            this.department_id.setValue(this.edit.department_id);
            this.responsable_id.setValue(this.edit.responsable_id);
            this.venue_id.setValue(this.edit.venue_id);
            this.description.setValue(this.edit.description);
            this.type_of_action.setValue(this.edit.type_of_action);
            this.source.setValue(this.edit.source);
            this.status.setValue(this.edit.status);
            this.progress.setValue(this.edit.progress);
            this.currency.setValue(this.edit.currency);
            this.materials.setValue(this.edit.materials);
            this.manpower.setValue(this.edit.manpower);
            this.methods.setValue(this.edit.methods);
            this.environment.setValue(this.edit.environment);
            this.machinery.setValue(this.edit.machinery);
            this.decisions_cause_root.setValue(this.edit.decisions_cause_root);
        } else {
            // this.activated.setValue(true);
        }
    }

    public cancelFinding () {
        console.log('reset');
        this.form.reset();
        this.close.emit(true);
    }


    public saveandexit (values){
        this.save_exit = true;
        this.newFinding(values);
    }

    public newFinding(values) {
        const param = {
            'department_id': values.department_id,
            'responsable_id': values.responsable_id.id,
            'venue_id': values.venue_id,
            'description': values.description,
            'type_of_action': values.type_of_action,
            'source': values.source,
            'status': values.status,
            'progress': values.progress,
            'currency': values.currency,
            'materials': values.materials,
            'manpower': values.manpower,
            'methods': values.methods,
            'environment': values.environment,
            'machinery': values.machinery,
            'decisions_cause_root': values.decisions_cause_root,
        };
        if (values && this.form.valid) {
            const promise = (this.edit) ?
                this.findingService.updateFinding(this.edit.id, param)
                :
                this.findingService.newFinding(param);

            this.promiseForm = promise.toPromise().then(
                response => {
                    this.translate.get('saved').subscribe((res: string) => {
                        this.notificationsService.growlNotify('success', res);
                        // this.msg.emit( { severity: 'success', summary: res  } );
                        if (this.save_exit) {
                            this.close.emit(true);
                            this.form.reset();
                            this.save_exit = false;
                        }
                    });
                },
                error => {
                    let msg = '';
                    this.translate.get(JSON.parse(error._body).errors[0].detail).subscribe((res1: string) => {
                        this.translate.get(JSON.parse(error._body).errors[1].detail).subscribe((res2: string) => {
                            JSON.parse(error._body).errors.forEach(element => {
                                if (element.source) {
                                    if (element.source.pointer) {
                                        this.translate.get(element.source.pointer).subscribe((res3: string) => {
                                            msg = msg + res3 + ', ';
                                        });
                                    }
                                }
                            });
                            this.notificationsService.growlNotify('error', res1 + ' ' + res2 + ': ' + msg);
                            // this.msg.emit( { severity: 'error', summary: 'Error' } );
                        });
                    });
                }
            );
        }
    }

    public formatDate(date) {
        const d = new Date(date);
        let month = '' + (d.getMonth() + 1);
        let day = '' + d.getDate();
        const year = d.getFullYear();
        let hours = '' + d.getHours();
        let minutes = '' + d.getMinutes();
        let seconds = '' + d.getSeconds();

        if (month.length < 2) {
            month = '0' + month;
        }
        if (day.length < 2) {
            day = '0' + day;
        }

        if (hours.length < 2) {
            hours = '0' + hours;
        }

        if (minutes.length < 2) {
            minutes = '0' + minutes;
        }

        if (seconds.length < 2) {
            seconds = '0' + seconds;
        }

        return [year, month, day].join('-');
    }

    getFormValidationErrors(form) {
        let value = '';
        Object.keys(form.controls).forEach(key => {
            const controlErrors: ValidationErrors = form.get(key).errors;
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    value = 'Key control: ' + key + ', keyError: ' + keyError + ', err value: ' + controlErrors[keyError];
                });
            }
        });
        return (value);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/findings/new-finding/new-finding.component.ts